var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amount-panel-container"},[_c('div',{staticClass:"label"},[_vm._v("应退金额")]),_c('div',{staticClass:"value"},[_vm._v("¥"+_vm._s(_vm._f("amount")(_vm.data.paidAmount)))])])}
var staticRenderFns = []

export { render, staticRenderFns }